var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 0H2.75C1.23 0 0 1.23 0 2.75V14.75C0 16.27 1.23 17.5 2.75 17.5H9.75C11.27 17.5 12.5 16.27 12.5 14.75V2.75C12.5 1.23 11.27 0 9.75 0ZM11 14.75C11 15.44 10.44 16 9.75 16H2.75C2.06 16 1.5 15.44 1.5 14.75V2.75C1.5 2.06 2.06 1.5 2.75 1.5H9.75C10.44 1.5 11 2.06 11 2.75V14.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 0C15.23 0 14 1.23 14 2.75V13.14C14 13.68 14.16 14.21 14.46 14.67L16.12 17.17C16.26 17.38 16.49 17.5 16.74 17.5C16.99 17.5 17.23 17.38 17.36 17.17L19.02 14.67C19.32 14.22 19.48 13.69 19.48 13.14V2.75C19.48 1.23 18.25 0 16.73 0H16.75ZM16.75 1.5C17.44 1.5 18 2.06 18 2.75V4H15.5V2.75C15.5 2.06 16.06 1.5 16.75 1.5ZM17.79 13.84L16.75 15.4L15.71 13.84C15.57 13.63 15.5 13.39 15.5 13.15V5.50999H18V13.15C18 13.4 17.93 13.64 17.79 13.84Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5H3.75C3.34 5 3 5.34 3 5.75C3 6.16 3.34 6.5 3.75 6.5H8.75C9.16 6.5 9.5 6.16 9.5 5.75C9.5 5.34 9.16 5 8.75 5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 8H3.75C3.34 8 3 8.34 3 8.75C3 9.16 3.34 9.5 3.75 9.5H7.75C8.16 9.5 8.5 9.16 8.5 8.75C8.5 8.34 8.16 8 7.75 8Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11H3.75C3.34 11 3 11.34 3 11.75C3 12.16 3.34 12.5 3.75 12.5H6.75C7.16 12.5 7.5 12.16 7.5 11.75C7.5 11.34 7.16 11 6.75 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.5bea380ac48f86155ee6bc1ac016c2de.svg";
export { ForwardRef as ReactComponent };